var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"homewrap"},[(_vm.$store.state.userToken)?_c('HomeLogged'):_c('HomePublic')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }